const resource = require('../utils/resource').default;
export default class RapidMessageModal {
  init() {
    $('body').on('addToCart:rapidMessage', (e, response) => {
      this.updateRapidMessage(response);

      setTimeout(() => {
        $('.rapid-message-dialog').addClass('showing');
      }, 400);

      setTimeout(() => {
        $('.rapid-message-dialog').removeClass('showing');
        $('.rapid-message-veil').addClass('d-none');
      }, 4000);
    });

    $('body').on('click', '.rapid-message-dialog .close, .rapid-message-veil', () => {
      $('.rapid-message-dialog').removeClass('showing');
      setTimeout(() => {
        $('.rapid-message-veil').addClass('d-none');
      }, 700);
    });
  }

  updateRapidMessage(response) {
    const lastAddedProduct = response.cart.items[response.cart.items.length - 1];

    $('.rapid-message-veil').removeClass('d-none');

    if ($('.product-set-detail').length > 0) {
      $('.rapid-message-dialog .img-placeholder').parent().addClass('d-none');
      $('.rapid-message-dialog .rapid-message-header .text-header')
        .empty()
        .text(resource.msg('text.alert.addalltobasket', 'product', null));
    } else {
      $('.rapid-message-dialog .img-placeholder')
        .attr('src', lastAddedProduct.images.small[0].url)
        .attr('alt', lastAddedProduct.productName);
      $('.rapid-message-dialog .product-brand-placeholder').empty().text(lastAddedProduct.brand);
      $('.rapid-message-dialog .product-name-placeholder').empty().text(lastAddedProduct.productName);
    }
  }
}
